module.exports = __webpack_public_path__ + "static/media/mavic_mini.a9f64ce8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Drone/mavic_mini.jpg
// module id = 318
// module chunks = 0